





























import { Vue, Component, Prop } from 'nuxt-property-decorator'
import { defineComponent, useRoute, computed } from '@nuxtjs/composition-api'
import queryString from 'query-string'
import BlockSectionTags from '@/components/BlockSectionTags.vue'

@Component({})
class CardOffice extends Vue {
  @Prop() readonly title: String = ''
  @Prop() readonly popup: boolean = false
  @Prop() readonly address: String = ''
  @Prop() readonly time: String = ''
  // eslint-disable-next-line camelcase
  @Prop() readonly country_translit: String = ''
  // eslint-disable-next-line camelcase
  @Prop() readonly city_translit: String = ''
  @Prop() readonly id: String = ''
  @Prop() readonly services: Object = {}
  static options: any
}

export default defineComponent({
  name: 'CardOffice',
  components: {
    BlockSectionTags,
  },
  props: CardOffice.options.props,
  setup(props: CardOffice.options.props) {
    const route = useRoute()
    const cardLink = computed(() => {
      const searchQueries = queryString.parse(window.location.search)
      return `${route.value.path}/${props.country_translit}/${props.city_translit}/${props.id}?$type=${searchQueries.type}`
    })

    return { cardLink }
  },
})
